<dx-form class="plain-styled-form" [screenByWidth]="getSizeQualifier">
    <dxi-item itemType="group">
        <dxo-col-count-by-screen
            [xs]="1"
            [sm]="2"
            [md]="2"
            [lg]="2"
        ></dxo-col-count-by-screen>
        <dxi-item>
            <dx-select-box
                label="Status:*"
                stylingMode='filled'
                valueExpr="value"
                displayExpr="text"
                [items]="supplierStatusOptions"
                [searchEnabled]="true"
                [showClearButton]="true"
                [(value)]="data.status"
                [readOnly]="isReadOnly"
            >
                <dx-validator>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dx-validator>
            </dx-select-box>
        </dxi-item>
        <dxi-item>
            <dx-text-box
                label="ID:*"
                [(value)]="data.number"
                stylingMode='filled'
                maxLength="20"
                [readOnly]="isReadOnly"
            >
                <dx-validator>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dx-validator>
            </dx-text-box>
        </dxi-item>
        <dxi-item>
            <dx-text-box
                label="Name:*"
                [(value)]="data.name"
                stylingMode='filled'
                maxLength="100"
                [readOnly]="isReadOnly"
            >
                <dx-validator>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dx-validator>
            </dx-text-box>
        </dxi-item>
        <dxi-item>
            <dx-text-box
                label="Group:"
                [(value)]="data.group"
                stylingMode='filled'
                maxLength="20"
                [readOnly]="isReadOnly"
            >
            </dx-text-box>
        </dxi-item>
        <dxi-item>
            <dx-text-box
                label="Plant:"
                [(value)]="data.plant"
                stylingMode='filled'
                maxLength="20"
                [readOnly]="isReadOnly"
            >
            </dx-text-box>
        </dxi-item>
        <dxi-item>
            <dx-text-box
                label="SAC:"
                [(value)]="data.sac"
                stylingMode='filled'
                maxLength="20"
                [readOnly]="isReadOnly"
            >
            </dx-text-box>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <dx-text-box
                stylingMode="filled"
                valueChangeEvent="keyup input change"
                label="Address:"
                [(value)]="data.address"
                maxLength="200"
                [readOnly]="isReadOnly"
            >
                <dxi-button
                    name="icon"
                    location="before"
                    [options]="{ icon: 'home', elementAttr: { class: 'form-editor-icon' }, stylingMode: 'text' }"
                ></dxi-button>
            </dx-text-box>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <dx-text-box
                stylingMode="filled"
                valueChangeEvent="keyup input change"
                label="Phone #:"
                mask="(000) 000-0000"
                [(value)]="data.phone"
                maxLength="20"
                [readOnly]="isReadOnly"
            >
                <dxi-button
                    name="icon"
                    location="before"
                    [options]="{ icon: 'tel', elementAttr: { class: 'form-editor-icon' }, stylingMode: 'text' }"
                ></dxi-button>
            </dx-text-box>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <dx-text-box
                stylingMode="filled"
                valueChangeEvent="keyup input change"
                label="Email:"
                [(value)]="data.email"
                maxLength="150"
                [readOnly]="isReadOnly"
            >
                <dxi-button
                    name="icon"
                    location="before"
                    [options]="{ icon: 'email', elementAttr: { class: 'form-editor-icon' }, stylingMode: 'text' }"
                ></dxi-button>
            </dx-text-box>
        </dxi-item>
    </dxi-item>
</dx-form>
